module.exports = __webpack_public_path__ + "media/images/home/boxes/Group 4176-ad42dafa235e9353bcbea0d2c3744b44.svg";